import React from 'react';
import { Text } from 'v3/components';

const themes = {
  dark: {
    textColor: 'white',
    activeCircleColor: '#1C4B75',
    inactiveCircleColor: 'rgba(255,255,255,0.25)',
    activeOpacity: 1,
    inactiveOpacity: 0.6,
  },

  light: {
    textColor: '#1C4B75',
    activeCircleColor: '#1C4B75',
    inactiveCircleColor: '#D9E2EC',
    activeOpacity: 1,
    inactiveOpacity: 0.7,
  },
};

export default function StepsRegisterImport({
  stepText = '',
  activeStep = false,
  variant = 'dark', // 'dark' or 'light'
}) {
  const {
    textColor,
    activeCircleColor,
    inactiveCircleColor,
    activeOpacity,
    inactiveOpacity,
  } = themes[variant];

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        justifyContent: 'flex-end',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <div
          style={{
            width: 28,
            height: 28,
            borderRadius: '50%',
            backgroundColor: activeCircleColor,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
          }}
        >
          <Text color="white" type="small" weight={700}>
            1
          </Text>
        </div>

        <Text color={textColor} type="regular" weight={600}>
          {stepText}
        </Text>
      </div>

      <Text
        color={textColor}
        type="regular"
        style={{
          opacity: activeStep ? activeOpacity : inactiveOpacity,
        }}
      >
        &gt;
      </Text>

      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <div
          style={{
            width: 28,
            height: 28,
            borderRadius: '50%',
            backgroundColor: activeStep
              ? activeCircleColor
              : inactiveCircleColor,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
            transition: 'background-color 0.3s',
          }}
        >
          <Text
            color={activeStep ? 'white' : textColor}
            type="small"
            weight={700}
          >
            2
          </Text>
        </div>

        <Text
          color={textColor}
          type="regular"
          weight={activeStep ? 600 : 400}
          style={{
            opacity: activeStep ? activeOpacity : inactiveOpacity,
            transition: 'opacity 0.3s',
          }}
        >
          Conferência de Dados
        </Text>
      </div>
    </div>
  );
}
